import React, { useCallback } from 'react';
import {
	TaxformInput,
	TaxformInputByCompanyType,
} from '../data/searchFlowText';
import Navigation from '../components/navigation/navigation';
import i18n from '../../../utils/i18n';
import { withTranslation } from 'react-i18next';
import RadioInput from '../components/searchInputs/radioInput';
import { useSelector } from 'react-redux';

const Taxform = ({ ...props }) => {
	const companyStore = useSelector((state) => state.company_store);
	const handleNext = useCallback(
		(inc) => {
			props.handleNext(inc);
		},
		[props]
	);

	const handleBack = useCallback(
		(decr) => {
			props.handleBack(decr);
		},
		[props]
	);

	// Get tax forms based on company type
	const getTaxFormsForCompanyType = () => {
		if (!companyStore.companytype || companyStore.companytype === 'idk') {
			return [];
		}
		return TaxformInputByCompanyType(companyStore.companytype);
	};

	return (
		<div className="stepContainer">
			<div className="SFInput">
				<p className="SFSubTitle">
					<span className="SFSubTitle">
						{i18n.t('searchflow.taxformlabel')}
					</span>{' '}
					<span className="questionTracker">2/6</span>
				</p>
				<RadioInput
					storeID="taxform"
					dataText={getTaxFormsForCompanyType()}
					stateObject="company_store"
				/>
			</div>

			<Navigation
				step={2}
				handleBack={() => handleBack()}
				handleNext={() => {
					handleNext();
				}}
				openHelpForm={() => props.openHelpForm()}
				disabledProp={
					companyStore.companytype === 'idk'
						? false
						: companyStore.taxform !== ''
						? false
						: true
				}
			/>
		</div>
	);
};

export default withTranslation()(Taxform);
